import { Grid, Tooltip} from "@mui/material";

export function getInventoryitemStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        creditcount:{
            name:'creditcount',
            label:'Credit Count',
            value:'',
            error:false,
            errorMessage:'You must enter Credit Count',
            required:true,
            fieldtype:'number'
        },
        debitcount:{
            name:'debitcount',
            label:'Debit Count',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        balance:{
            name:'balance',
            label:'Balance',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'Product Name',
            value:'',
            error:false,
            errorMessage:'You must enter Product Name',
            required:true,
            fieldtype:'string'
        },
        type:{
            name:'type',
            label:'Type',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        ops:{
            name:'ops',
            label:'Ops',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'creditcount', headerName: 'Credit Count', width:150 },
        { field: 'debitcount', headerName: 'Debit Count', width:150 },
        { field: 'balance', headerName: 'Balance', width:150 },
        { field: 'productid', headerName: 'Product Id', width:150 },
        { field: 'productname', headerName: 'Product Name', width:150 },
        { field: 'type', headerName: 'Type', width:150 },
        { field: 'ops', headerName: 'Ops', width:150 },
        { field: 'orderid', headerName: 'Order Id', width:150 },
        { field: 'partyname', headerName: 'Party Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['creditcount']:{
          ...formValues['creditcount'],
          value:data.creditcount,
        },['debitcount']:{
          ...formValues['debitcount'],
          value:data.debitcount,
        },['balance']:{
          ...formValues['balance'],
          value:data.balance,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['type']:{
          ...formValues['type'],
          value:data.type,
        },['ops']:{
          ...formValues['ops'],
          value:data.ops,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },
      })
}